<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="false"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [offsetRect]="offsetRect"
  [zoomScale]="zoomScale"
  [role2ColorMapping]="role2ColorMapping"
  [isCustomField]="false"
  [isValueCustomizable]="false"
  [prefillType]="prefillType"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
>
  <ng-container class="title">
    <i class="mr-2" [ngClass]="icon"></i> <ng-container i18n>User Name</ng-container>
  </ng-container>
  <ng-container class="label"> <i [ngClass]="icon"></i> {{ fieldValue }} </ng-container>
</app-field-renderer>
